import styled from "@emotion/styled";
import React from "react";
import LottiePlayer from "./LottiePlayer";

import middleAnimationData from "../../../../assets/spinner/VF_Living_Speechmark_drawn_on_Lottie_Red_1200.json";

const ParentDiv = styled.div([
    {
        height: "100%",
    }
]);

const SubParentDiv = styled.div([
    {
        height: "128%",
        marginTop: "-12%",
        marginBottom: "16%",

        paddingTop: 2,
    }
]);

interface SpeechmarkProps { }

const Speechmark: React.FC<SpeechmarkProps> = () => (
    <ParentDiv>
        <SubParentDiv>
            <LottiePlayer animationData={middleAnimationData} />
        </SubParentDiv>
    </ParentDiv>
)

export default Speechmark;